import { Box, Icon, Typography } from '@mui/material'
import AdxInput from 'components/custom/AdxInput'
import AdxButton from 'components/custom/AdxButton'
import AdxFormModal from 'components/reusable/modal/AdxFormModal'
import React, { useState } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { sendSubmission } from 'services/api/modules/performance/appraisal/submission'

const PFeedbackModal = ({ submissionId, status }) => {
  const navigate = useNavigate()
  const [isModalOpen, setModalOpen] = useState(false)
  const [feedbackInput, setFeedbackInput] = useState('')
  const queryClient = useQueryClient()

  const { mutate: submitMutate } = useMutation((values) => sendSubmission(submissionId, values), {
    onSuccess: async () => {
      queryClient.invalidateQueries('getFeedback')
      queryClient.resetQueries('getFeedback')
    },
  })

  const handleOpen = () => {
    setModalOpen(true)
  }

  const handleClose = () => {
    setModalOpen(false)
  }

  const handleSubmit = () => {
    setModalOpen(false)
    submitMutate({
      reviewee_feedback: feedbackInput,
    })
    setFeedbackInput('')
  }

  const handleView = () => {
    navigate(`/app/performance/view-result/${submissionId}`)
  }

  return (
    <>
      {status === 'Completed' && (
        <AdxButton variant={'outlined'} sx={{ width: 250 }} onClick={handleOpen}>
          Leave a feedback
        </AdxButton>
      )}
      <AdxFormModal
        open={isModalOpen}
        onClose={handleClose}
        handleClose={handleClose}
        sxModal={{
          width: '800px',
          height: '75vh',
          position: 'relative',
        }}
        customHeader={
          <Box display="flex" justifyContent="space-between" alignItems="center" p={2.5}>
            <Typography variant="h4">My feedback</Typography>
            <Icon onClick={handleClose} sx={{ cursor: 'pointer' }}>
              close
            </Icon>
          </Box>
        }
      >
        <Typography mb={2}>
          You have not submitted your feedback yet. Share your feedback or any opinion on how you
          feel about the evaluation made on you.
        </Typography>
        <AdxInput
          sxLabel={{
            color: 'alternate.main',
          }}
          size="standard"
          placeholder="My feedback are..."
          multiline
          // charLimit={500}
          minRows={10}
          onChange={(e) => setFeedbackInput(e.target.value)}
          value={feedbackInput}
        />
        <Box
          sx={{
            width: '100%',
            padding: 3,
            position: 'fixed',
            left: 0,
            bottom: 0,
          }}
        >
          <AdxButton
            variant={'contained'}
            fullWidth
            onClick={handleSubmit}
            disabled={feedbackInput === '' ? true : false}
          >
            Submit
          </AdxButton>
        </Box>
      </AdxFormModal>
    </>
  )
}

export default PFeedbackModal
